import { createApp } from 'vue';
import { createPinia } from 'pinia';

import authUserGlobalMixin from '@/mixins/auth-user.global-mixin';
import i18n from '@/i18n';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import '@/mixins';

import 'vuetify/styles';
import '@/styles/index.scss';
import './plugins';
import '@mdi/font/css/materialdesignicons.css';

import mqttInstance from './plugins/mqtt';
import { setupAxiosInterceptors } from './plugins/axios';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';
import useAuthStore from '@/store/modules/pinia/auth';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

setupAxiosInterceptors(useUtilsStore(), useAuthStore(), mqttInstance);

app.mixin(authUserGlobalMixin);

app.use(router);
app.use(i18n);
app.use(vuetify);

// Attach dependencies to window for ngVue and Cypress
window.app = app;
window.router = router;
window.i18n = i18n;
window.vueApp = App;
window.vuetify = vuetify;

if (window.Cypress) {
  window.pinia = pinia;
}

app.config.globalProperties.$mqtt = mqttInstance;

app.mount('#app');
